import React, { useEffect, useState } from "react";
import { IonPage, IonCard, IonCardHeader, IonCardContent, IonIcon, IonButton, IonHeader, IonImg, IonFooter, getPlatforms } from '@ionic/react';
import { construct } from "ionicons/icons";

import { setStyleMode } from "../../utils/StyleUtils";

import Footer from "../Footer/Footer";
import prismaLogo from '../../assets/prismaLogo.png'
import prismaLogoDark from '../../assets/prismaLogoDark.png'

import "./MaintenancePage.css";

const MaintenancePage: React.FC<any> = (): JSX.Element => {

    const [shouldRefresh, setShouldRefresh] = useState(false);
    const desktop = getPlatforms().includes("desktop")

    useEffect(() => {

        function handleResize() {
            setShouldRefresh(true);
        }

        if (desktop) {
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }

    }, []);

    useEffect(() => {
        if (shouldRefresh) {
            setShouldRefresh(false);
            window.location.reload();
        }
    }, [shouldRefresh]);

    useEffect(() => {
        setStyleMode()
    }, [])

    const logout = () => {
        window.location.href = "/page/logout";
    }

    return (
        <IonPage className="maintenance-container">
            {localStorage.getItem("styleMode") === "dark" ?
                <IonHeader className="maintenance-header">
                    <IonImg id="logoDark" className="maintenance-img-logo" src={prismaLogoDark} />
                </IonHeader>
                :
                localStorage.getItem("styleMode") === "light" ?
                    <IonHeader className="maintenance-header">
                        <IonImg id="logoLight" className="maintenance-img-logo" src={prismaLogo} />
                    </IonHeader>
                    :
                    <IonHeader className="maintenance-header" />
            }
            <IonCard className="maintenance-card">
                <IonCardHeader className="maintenance-card-header">
                    <IonIcon className="maintenance-card-icon" icon={construct} />
                </IonCardHeader>
                <IonCardContent className="maintenance-card-text">
                    Disculpe las molestias, el Sistema se encuentra en mantenimiento.
                </IonCardContent>
                <IonCardContent className="maintenance-card-text">
                    Por favor intente más tarde
                </IonCardContent>
                <IonCardContent className="maintenance-card-text">
                    <IonButton fill="outline" className="maintenance-button" onClick={logout}> VOLVER AL INICIO</IonButton>
                </IonCardContent>
            </IonCard>
            <IonFooter className="maintenance-footer">
                <Footer />
            </IonFooter>
        </IonPage>
    );
}

export default MaintenancePage;